import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { MdLink } from 'react-icons/md'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton
} from 'react-share'
import Slider from 'react-slick'
import { Button, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { showNotification } from '../../../actions/notification'
import mockImagesWithID from '../../../helpers/mockImagesWithID'
import { RightArrow, ShareViaText, UrlField } from './SelectMedia/SelectMediaStyledComponents'
import ImageThumbnail from './SelectMedia/SliderElements/ImageThumbnail'
import { NextArrow, PrevArrow } from './SelectMedia/SliderElements/SliderArrows'
import './slider.scss'
import { ModalHeaderContainer, ModalTitle } from './SocialShareStyledComponents'

const excludeSocialIds = ['x1', 'x2', 'x5']

const mediaRowStyle = {
  adaptiveHeight: true,
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  paddingTop: '20px',
  centerMode: true,
  centerPadding: '100px',
  variableWitdth: true
}

const MediaRow = ({ ShareButton, Icon, url, text, media }) => (
  <Row>
    <ShareButton url={url} media={media} style={mediaRowStyle}>
      <Icon size={32} />
      <ShareViaText>
        <FormattedMessage id='share.via' /> {text}
      </ShareViaText>
      <RightArrow />
    </ShareButton>
  </Row>
)
MediaRow.propTypes = {
  ShareButton: PropTypes.object.isRequired,
  Icon: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
  media: PropTypes.string // For Pinterest
}

function ShareModal ({ isOpen, socialPhotos = [], itemUrl, className, toggle }) {
  const intl = useIntl()
  const dispatch = useDispatch()
  const activeStore = useSelector(state => state.activeStore)
  const filteredPhotos = socialPhotos.filter(item => !excludeSocialIds.some(id => item.image_id === id))
  const photos = mockImagesWithID(filteredPhotos)
  const [selectedImage, setSelectedImage] = useState(photos[0])
  const shareLink = itemUrl + '?image_id=' + selectedImage.image_id
  const storeMainImage = activeStore.getSocialPhoto()
  const isZeroTouch = activeStore.source === 'ZEROTOUCH'

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    slidesToShow: 1,
    afterChange: index => setSelectedImage(photos[index]),
    adaptiveHeight: true,
    className: 'productSlider'
  }

  const onCopy = () =>
    dispatch(showNotification({
      title: intl.formatMessage({ id: 'shareCodes.copiedLabel' }),
      type: 'info',
      message: ' '
    }))

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className={`${className} text-center`}
      size='lg'
    >
      <ModalHeader toggle={toggle} tag={ModalHeaderContainer}>
        <ModalTitle>
          <FormattedMessage id='store.actions.share.share' /> {activeStore.name}
        </ModalTitle>
      </ModalHeader>
      <Slider {...sliderSettings}>
        {photos.map(image => <ImageThumbnail key={image.image_id} url={image.url} id={image.image_id} />)}
      </Slider>
      <ModalBody>
        <Row>
          <div className='pt-0' style={mediaRowStyle}>
            <CopyToClipboard text={shareLink} onCopy={onCopy} style={{ flex: '1 1 auto', maxHeight: '30px' }}>
              <UrlField onClick={onCopy}>{shareLink}</UrlField>
            </CopyToClipboard>
            <CopyToClipboard text={shareLink} onCopy={onCopy} style={{ flex: '0 0 125px' }}>
              <Button color='link'>
                <span style={{ fontSize: 'larger' }}>
                  <MdLink />
                  <FormattedMessage id='shareCodes.copyButton' />
                </span>
              </Button>
            </CopyToClipboard>
          </div>
        </Row>
        <MediaRow
          ShareButton={FacebookShareButton}
          Icon={FacebookIcon}
          url={shareLink}
          text="Facebook" />
        <MediaRow
          ShareButton={LinkedinShareButton}
          Icon={LinkedinIcon}
          url={shareLink}
          text="LinkedIn" />
        <MediaRow
          ShareButton={TwitterShareButton}
          Icon={TwitterIcon}
          url={shareLink}
          text="Twitter" />
        <MediaRow
          ShareButton={PinterestShareButton}
          Icon={PinterestIcon}
          url={shareLink}
          media={storeMainImage}
          text="Pinterest" />
        <Row>
          <EmailShareButton
            url={shareLink}
            subject={isZeroTouch ? 'Delicious Menu' : 'Awesome HausMart !!!'}
            body={`Check out this ${isZeroTouch ? 'Menu' : 'HausMart'} ${shareLink}`}
            style={mediaRowStyle}
          >
            <EmailIcon size={32} />
            <ShareViaText>
              <FormattedMessage id='share.via' /> Email
            </ShareViaText>
            <RightArrow />
          </EmailShareButton>
        </Row>
      </ModalBody>
    </Modal>
  )
}

ShareModal.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  itemName: PropTypes.string.isRequired,
  socialPhotos: PropTypes.array.isRequired,
  itemUrl: PropTypes.string.isRequired
}
export default ShareModal
